import {
  TOGGLE_DMX_CONTROLLER_STATUS,
  TOGGLE_DMX_CONTROLLER_STATUS_SUCCESSFUL,
  TOGGLE_DMX_CONTROLLER_STATUS_FAILED,
} from './actionTypes';

export const toggleDmxControllerStatus = (controller) => {
  return {
    type: TOGGLE_DMX_CONTROLLER_STATUS,
    payload: { controller },
  };
};

export const toggleDmxControllerStatusSuccessful = (message) => {
  return {
    type: TOGGLE_DMX_CONTROLLER_STATUS_SUCCESSFUL,
    payload: message,
  };
};

export const toggleDmxControllerStatusFailed = (message) => {
  return {
    type: TOGGLE_DMX_CONTROLLER_STATUS_FAILED,
    payload: message,
  };
};
